/**
 * Generates a URL-friendly slug from a given text string.
 * Converts to lowercase, replaces spaces with hyphens,
 * and removes non-alphanumeric characters (except hyphens).
 */
export const generateSlug = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};
